import { render, staticRenderFns } from "./TibBannerForm.vue?vue&type=template&id=0eb9c034"
import script from "./TibBannerForm.vue?vue&type=script&lang=js"
export * from "./TibBannerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports